module.exports = __webpack_public_path__ + "img/1_021.6ed57e79.jpg";